import { gql } from '@apollo/client';

export const UPDATE_ADDRESS = gql`
  mutation UPDATE_ADDRESS($id: ID!, $input: AddressInput!) {
    opsShippingAddress(id: $id) {
      address: update(input: $input)
    }
  }
`;
